module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-atmosphere-pool.73420ce9.webp";